module.exports = __webpack_public_path__ + "img/user.e8dbe1f8.svg";